import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <div style={{
        backgroundColor:"#050402",
        justifyContent:"center",
        alignContent:"space-evenly",
        alignItems:"center",
justifyItems:"center"
    }}>
         <div className='flex flex-col items-center text-center'>
          <h2  style={{

          }} className='section-title before:content-github relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block'>
GitHub Contribution          </h2>
          <p className='subtitle'>
           
          </p>
        </div>
    {/* <h1 style={{
        color:"black",
        marginLeft:"30%"
      }} className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          GitHub Contributions
        </h1> */}
    <Row style={{ justifyContent: "center", paddingBottom: "10px",color:"#AC6B34"  }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px",
    color:"#02e0dd", fontSize:"30px",        marginLeft:"45%"
}}>
        Days I <strong className="white">Code</strong>
      </h1>
      <GitHubCalendar
      className="project-heading"
       style={{width:"80%",marginLeft:"13%" , backgroundColor:""}}
        username="THESHIVAM007"
        
        blockSize={15}
        blockMargin={5}
        color="#02e0dd"
        fontSize={18} 
    
        />
    </Row>
        </div>
  );
}

export default Github;